module.exports = __webpack_public_path__ + "img/sigurd.6e01ff3b.png";